/** Formate un prix en GNF — ex: 4 200 000 GNF */
export function formatPrice(amount) {
  return new Intl.NumberFormat('fr-GN', {
    style: 'currency',
    currency: 'GNF',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount)
}

/** Traduit un objet { fr, en } selon la langue courante */
export function t(obj, lang) {
  if (!obj) return ''
  if (typeof obj === 'string') return obj
  return obj[lang] ?? obj.fr ?? ''
}
